export default "__VITE_ASSET__DqwtgZH$__"